document.addEventListener('DOMContentLoaded', function() {
    console.log('photo-swipe fix');
    // Wait for PhotoSwipe to initialize
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.classList && node.classList.contains('pswp--open')) {
                    // PhotoSwipe opened - manage focus
                    console.log('photo-swipe open 2');
                    setTimeout(() => {
                        announcePhotoSwipe(node);
                    }, 100);
                }
            });
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
    
    function announcePhotoSwipe(pswpElement) {
        // Just announce to screen readers, don't worry about Tab navigation
        pswpElement.setAttribute('role', 'dialog');
        pswpElement.setAttribute('aria-modal', 'true');
        pswpElement.setAttribute('aria-label', 'Product image gallery. Use arrow keys to navigate, escape to close.');
        
        // Brief focus for screen reader announcement, then remove tabindex
        pswpElement.setAttribute('tabindex', '-1');
        pswpElement.focus();
        setTimeout(() => {
            pswpElement.removeAttribute('tabindex');
        }, 100);
    }
});